import styled from 'styled-components'

export const Button = styled.button`
  background-color: #F6D617;
  border: none;
  font-family: 'ubuntu';
  font-weight: bold;
  font-size: 20px;
  color: #000;
  margin: 0 auto;
  border-radius: 30px;

  &:hover {
    color: #F6D617;
    background-color: #000;
  }
`
